<template>
	<section class="featured-banner">
		    
    <div>
		  <ul>
		    <li v-for="(item, index) in banner_images" :key="'banner-item-' + index">
			    <div class="banner-image">{{ item.banner_image.url }}</div>
			    <h2>{{ item.banner_title }}</h2>
			    <h3>{{ item.banner_subtitle }}</h3>
		      <prismic-link :field="item.banner_link" class="btn">
		        <span><strong>{{ item.banner_cta }}</strong></span>
		      </prismic-link>
		    </li>
		  </ul>
		</div>
	    
	</section>
</template>

<script>
export default {
  name: 'FeaturedBanner',
  data () {
    return {
    	banner_images:[]
    }
  },
	methods: {
		getContent () {
		  this.$prismic.client.getSingle('homepage')
		  	.then((document) => {
			  	this.banner_images = document.data.featured_banner;
		  	})
	  }
	},
	created () {
	  this.getContent();
  }
}
</script>